var map = {
	"./comment-active.svg": "7b32",
	"./comment-disabled.svg": "0d74",
	"./comment.svg": "689e",
	"./delete.svg": "01b0",
	"./delete_disable.svg": "1d1c",
	"./export.svg": "3742",
	"./next.svg": "22f2",
	"./previous.svg": "a975",
	"./save-hover.svg": "2fa6",
	"./save.svg": "ed24",
	"./save_disabled.svg": "9e7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4846";